// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"889ae3bb","93":"a30fd9f1","136":"e97c9188","220":"8f99d3ec","271":"2cdf552d","457":"a612074a","466":"5e2ff610","565":"66dc0e8f","768":"b0aca57d","783":"7059641d","860":"b5bce8e1"}[chunkId] + ".chunk.js";
};